dvs([0],{

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_application_js__ = __webpack_require__(33);



new __WEBPACK_IMPORTED_MODULE_1__shared_application_js__["a" /* default */]({
  data: function data() {
    return {
      location: 0,
      season: 'all',
      type: 'all',

      events: [],
      searchID: '',
      hasMoreResults: false,
      resultPage: 1,

      videoSource: 'youtube',
      videoID: ''
    };
  },


  methods: {
    init: function init() {
      this.setData();
    },
    updateSearch: function updateSearch() {
      this.resultPage = 1;
      this.updateResults();
    },
    updateResults: function updateResults() {
      var _this = this;

      this.$http.get(location.path || '/', {
        params: {
          location: this.location,
          season: this.season,
          type: this.type,
          page: this.resultPage
        }
      }).then(function (response) {
        var data = response.data;
        if (_this.resultPage === 1) {
          _this.events = data.events;
        } else {
          _this.events = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.events), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.events));
        }

        _this.hasMoreResults = data.moreResults;

        var search = data.search;
        if (search.hash !== _this.searchID) {
          _this.searchID = search.hash;
          _this.updateUrlForSearch(data.search);
        }
      });
    },
    updateUrlForSearch: function updateUrlForSearch(search) {
      var path = location.path || '/';
      history.pushState({ search: search }, 'zoekresultaat', path + '?search=' + search.hash);
    },
    listenForSearchChange: function listenForSearchChange() {
      var _this2 = this;

      window.addEventListener('popstate', function (event) {
        if (!event.state || !event.state.search) {
          return;
        }

        var search = event.state.search;
        _this2.setSearchProperties(search);
        _this2.updateSearch();
      });
    },
    setSearchProperties: function setSearchProperties(search) {
      if (!search || !search.properties) {
        return;
      }

      var props = search.properties;
      for (var key in props) {
        this[key] = props[key];
      }

      this.searchID = search.hash;
    },
    loadMoreResults: function loadMoreResults() {
      this.resultPage++;
      this.updateResults();
    },
    gotoEvent: function gotoEvent(event) {
      location.href = event.url;
    },
    setData: function setData() {
      this.location = _state.location;
      this.events = _state.events.events;
      this.hasMoreResults = _state.events.moreResults;
      this.setSearchProperties(_state.events.search);
    },
    showVideo: function showVideo(source, videoID) {
      this.videoSource = source;
      this.videoID = videoID;
      this.$modal.open('video');
    },
    closeVideo: function closeVideo() {
      var _this3 = this;

      setTimeout(function () {
        _this3.videoID = '';
      }, 300);
    }
  },

  created: function created() {
    this.init();
    this.listenForSearchChange();
  },
  mounted: function mounted() {
    try {
      this.$modal.open('corona');
    } catch (e) {
      // nada
    }
  }
});

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(233);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(234), __esModule: true };

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(118);
__webpack_require__(235);
module.exports = __webpack_require__(15).Array.from;


/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(46);
var $export = __webpack_require__(34);
var toObject = __webpack_require__(124);
var call = __webpack_require__(126);
var isArrayIter = __webpack_require__(127);
var toLength = __webpack_require__(81);
var createProperty = __webpack_require__(236);
var getIterFn = __webpack_require__(128);

$export($export.S + $export.F * !__webpack_require__(133)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(36);
var createDesc = __webpack_require__(74);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ })

},[231]);


// WEBPACK FOOTER //
// js/home.71bc5e89.js